import styled from '@emotion/styled';

export const Page = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  background-color: var(--surface-sunken);
`;
export const Header = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;
export const Navigation = styled.div`
  display: flex;
  gap: 10px;
  padding: 10px;
  width: 100%;
`;
export const Profile = styled.div`
  display: flex;
  margin-right: 20px;
`;
export const Username = styled.div`
  padding: 10px;
  white-space: nowrap;
`;
